import API from "../../../Common/Network/API";
import Alert from "../../../Common/Alert";


export async function addCommentUserStory(getUser,userStoryId,message,cardId) {
    try {
      const response = await API.post(
        "story_comments.php",
        {
          action: "add_story_comment",
          storyId: userStoryId,
          corp: getUser.corp,
          userId: getUser.empId,
          message: message,
          cardId: cardId,
        },
        {},
        false
      );
      if (response.status === "True") {
      } else {
        Alert("warning", response.message);
      }
    } catch (error) {
      Alert("error", error.message);
    }
  }